import MoveLeft from './move-left';
import MoveRight from './move-right';
import MoveCenter from './move-center';
import AlertCircle from './alert-circle';
import AlignCenter from './align-center';
import AlignJustify from './align-justify';
import AttentionCircle from './attention-circle';
import AlignLeft from './align-left';
import AlignRight from './align-right';
import Archive from './archive';
import ArrowUpCircle from './arrow-up-circle';
import ArrowUp from './arrow-up';
import ArrowDown from './arrow-down';
import AspectRatio from './aspect-ratio';
import Ai from './ai';
import Bold from './bold';
import Calendar from './calendar';
import Customize from './customize';
import Cart from './cart';
import Clock from './clock';
import Check from './check';
import Checkboxes from './checkboxes';
import CheckboxSquare from './checkbox-square';
import ChevronDown from './chevron-down';
import ChevronUp from './chevron-up';
import ChevronLeft from './chevron-left';
import ChevronRight from './chevron-right';
import Code from './code';
import Content from './contents';
import Markup from './markup';
import Command from './command';
import Compass from './compass';
import Component from './component';
import ComponentDetached from './component-detached';
import Copy from './copy';
import CreditCard from './credit-card';
import Database from './database';
import Delete from './delete';
import Desktop from './desktop';
import DoubleCheck from './double-check';
import DownloadCloud from './download-cloud';
import Download from './download';
import Dropdown from './dropdown';
import Drag from './drag';
import ExternalLink from './external-link';
import Edit from './edit';
import Email from './email';
import EyeOff from './eye-off';
import Eye from './eye';
import Facebook from './facebook';
import Filter from './filter';
import Floppy from './floppy';
import Folder from './folder';
import FolderMinus from './folder-minus';
import FolderPlus from './folder-plus';
import Mailbox from './mailbox';
import Gift from './gift';
import Gallery from './gallery';
import Grid from './grid';
import HelpCircle from './help-circle';
import Home from './home';
import Iframe from './iframe';
import Image from './image';
import Info from './info';
import InfoPaywall from './info-paywall';
import Instagram from './instagram';
import InfoItalic from './info-italic';
import Italic from './italic';
import Layers from './layers';
import Layout from './layout';
import LifeBuoy from './life-buoy';
import Link from './link';
import Linkedin from './linkedin';
import List from './list';
import UnorderedList from './unordered-list';
import Lock from './lock';
import LogIn from './log-in';
import LogOut from './log-out';
import Mail from './mail';
import MapPin from './map-pin';
import Map from './map';
import Maximize from './maximize';
import Menu from './menu';
import MessageSquare from './message-square';
import Minimize from './minimize';
import Minus from './minus';
import Monitor from './monitor';
import MoreVertical from './more-vertical';
import MoreHorizontal from './more-horizontal';
import Move from './move';
import MultiLine from './multi-line';
import Hierarchy from './hierarchy';
import OrderedList from './ordered-list';
import Phone from './phone';
import Plus from './plus';
import ReferAFriend from './refer-a-friend';
import Request from './request';
import Rocket45 from './rocket-45';
import Settings from './settings';
import Share from './share';
import ShareSocial from './share-social';
import ShoppingBag from './shopping-bag';
import SingleLine from './single-line';
import Smartphone from './smartphone';
import Star from './star';
import Tablet from './tablet';
import Tag from './tag';
import Terminal from './terminal';
import ThumbsUp from './thumbs-up';
import ThumbsDown from './thumbs-down';
import Time from './time';
import Trash from './trash';
import Type from './type';
import Twitter from './twitter';
import Underline from './underline';
import Unlock from './unlock';
import UploadCloud from './upload-cloud';
import Upload from './upload';
import User from './user';
import Users from './users';
import UserSearch from './user-search';
import X from './x';
import ZoomIn from './zoom-in';
import ZoomOut from './zoom-out';
import Undo from './undo';
import Redo from './redo';
import TypeClean from './type-clean';
import FontSize from './font-size';
import Heading1 from './heading-1';
import Heading2 from './heading-2';
import Heading3 from './heading-3';
import Heading4 from './heading-4';
import Heading5 from './heading-5';
import Heading6 from './heading-6';
import Paragraph from './paragraph';
import Quote from './quote';
import NSResize from './ns-resize';
import NWSEResize from './nwse-resize';
import Fill from './fill';
import Fit from './fit';
import Search from './search';
import Smile from './smile';
import Magic from './magic';
import Overlay from './overlay';
import ViewPublish from './view-publish';
import Help from './help';
import OnlineStore from './online-store';
import Advertising from './advertising';
import Analytics from './analytics';
import Domain from './domain';
import Date from './date';
import Translate from './translate';
import ContactForm from './contact-form';
import Columns from './columns';
import Button from './button';
import Buttons from './buttons';
import Images from './images';
import Crop from './crop';
import CustomBlock from './custom-block';
import Avatar from './avatar';
import Briefcase from './briefcase';
import Boy from './boy';
import Handshake from './handshake';
import Hospitality from './hospitality';
import IdCard from './id-card';
import WriteComment from './write-comment';
import Store from './store';
import Social from './social';
import RadioButtons from './radio-buttons';
import Play from './play';
const icons = {
  'alert-circle': AlertCircle,
  'align-center': AlignCenter,
  'align-justify': AlignJustify,
  'align-left': AlignLeft,
  'align-right': AlignRight,
  archive: Archive,
  'arrow-up-circle': ArrowUpCircle,
  'arrow-up': ArrowUp,
  'arrow-down': ArrowDown,
  'aspect-ratio': AspectRatio,
  'attention-circle': AttentionCircle,
  ai: Ai,
  bold: Bold,
  customize: Customize,
  calendar: Calendar,
  cart: Cart,
  clock: Clock,
  check: Check,
  checkboxes: Checkboxes,
  'checkbox-square': CheckboxSquare,
  'chevron-down': ChevronDown,
  'chevron-up': ChevronUp,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  code: Code,
  crop: Crop,
  'custom-block': CustomBlock,
  content: Content,
  markup: Markup,
  'move-left': MoveLeft,
  'move-right': MoveRight,
  'move-center': MoveCenter,
  command: Command,
  compass: Compass,
  component: Component,
  'component-detached': ComponentDetached,
  copy: Copy,
  database: Database,
  'credit-card': CreditCard,
  delete: Delete,
  desktop: Desktop,
  'download-cloud': DownloadCloud,
  download: Download,
  'double-check': DoubleCheck,
  drag: Drag,
  dropdown: Dropdown,
  edit: Edit,
  'external-link': ExternalLink,
  email: Email,
  'eye-off': EyeOff,
  eye: Eye,
  facebook: Facebook,
  filter: Filter,
  floppy: Floppy,
  folder: Folder,
  'folder-minus': FolderMinus,
  'folder-plus': FolderPlus,
  mailbox: Mailbox,
  gift: Gift,
  grid: Grid,
  gallery: Gallery,
  'help-circle': HelpCircle,
  hierarchy: Hierarchy,
  home: Home,
  image: Image,
  iframe: Iframe,
  info: Info,
  'info-paywall': InfoPaywall,
  'info-italic': InfoItalic,
  italic: Italic,
  layers: Layers,
  layout: Layout,
  'life-buoy': LifeBuoy,
  link: Link,
  linkedin: Linkedin,
  list: List,
  'unordered-list': UnorderedList,
  'ordered-list': OrderedList,
  lock: Lock,
  'log-in': LogIn,
  'log-out': LogOut,
  mail: Mail,
  'map-pin': MapPin,
  map: Map,
  maximize: Maximize,
  menu: Menu,
  'message-square': MessageSquare,
  minimize: Minimize,
  minus: Minus,
  monitor: Monitor,
  'more-vertical': MoreVertical,
  'more-horizontal': MoreHorizontal,
  move: Move,
  'multi-line': MultiLine,
  phone: Phone,
  plus: Plus,
  'refer-a-friend': ReferAFriend,
  'rocket-45': Rocket45,
  request: Request,
  settings: Settings,
  'share-social': ShareSocial,
  share: Share,
  'shopping-bag': ShoppingBag,
  'single-line': SingleLine,
  smartphone: Smartphone,
  star: Star,
  tablet: Tablet,
  tag: Tag,
  terminal: Terminal,
  'thumbs-up': ThumbsUp,
  'thumbs-down': ThumbsDown,
  time: Time,
  trash: Trash,
  type: Type,
  twitter: Twitter,
  underline: Underline,
  unlock: Unlock,
  'upload-cloud': UploadCloud,
  upload: Upload,
  user: User,
  users: Users,
  'user-search': UserSearch,
  x: X,
  'zoom-in': ZoomIn,
  'zoom-out': ZoomOut,
  undo: Undo,
  redo: Redo,
  'type-clean': TypeClean,
  'font-size': FontSize,
  'heading-1': Heading1,
  'heading-2': Heading2,
  'heading-3': Heading3,
  'heading-4': Heading4,
  'heading-5': Heading5,
  'heading-6': Heading6,
  paragraph: Paragraph,
  quote: Quote,
  'ns-resize': NSResize,
  'nwse-resize': NWSEResize,
  fill: Fill,
  fit: Fit,
  search: Search,
  smile: Smile,
  magic: Magic,
  overlay: Overlay,
  'view-publish': ViewPublish,
  help: Help,
  'online-store': OnlineStore,
  advertising: Advertising,
  analytics: Analytics,
  domain: Domain,
  date: Date,
  translate: Translate,
  'contact-form': ContactForm,
  columns: Columns,
  button: Button,
  buttons: Buttons,
  images: Images,
  instagram: Instagram,
  avatar: Avatar,
  briefcase: Briefcase,
  boy: Boy,
  handshake: Handshake,
  hospitality: Hospitality,
  'id-card': IdCard,
  'write-comment': WriteComment,
  store: Store,
  social: Social,
  'radio-buttons': RadioButtons,
  play: Play,
};

const getGlyph = (name) => icons[name];

export const iconsList = Object.keys(icons);
export default getGlyph;
